module.exports = __webpack_public_path__ + "img/workflow_2.b07d4bb8.jpg";